import { FaFile } from 'react-icons/fa';
import styled from 'styled-components';

import { Table, TableCell } from '@gbs-monorepo-packages/common';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 1rem;
  overflow: auto;
`;

export const TableCustom = styled(Table)`
  width: 100%;
  margin-bottom: 0.5rem;
`;

export const TableCellCustom = styled(TableCell)`
  padding: 1rem;
`;

export const FileIcon = styled(FaFile)`
  height: 1.5rem;
  width: 1.5rem;
`;
